import { PaysafeEvent } from './paysafe-event.interface';
import { PaysafeInstance } from './paysafe-instance.interface';

export type PaysafeEventHandler = (
  instance: PaysafeInstance,
  event: PaysafeEvent
) => unknown;
